import { Route } from 'react-router-dom';
import { SignUpPage } from '../pages/SignUpPage';

export const authRoutes = (
  <>
    <Route path="/signup" element={<SignUpPage />} />
  </>
);